
<form [formGroup]="SummaryFormGroup">

  <p><b>You are almost done.</b></p>
  <p>Please review below information and click the 'Save' button</p>
  <br />

  <table datatable [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
    <tbody>
      <tr>
        <td style="background-color: #348cd4; color: white " colspan="2"><b>Merchant information section</b></td>
      </tr>
      <tr>
      <tr>
        <td><b>Shop name:</b></td>
        <td> {{ SummaryFormGroup.value.shopName }} </td>
      </tr>
      <tr>
        <td><b>Merchant number:</b></td>
        <td>  {{SummaryFormGroup.value.merchantNumber}}</td>
      </tr>
      <tr>
        <td><b>Merchant config:</b></td>
        <td> {{SummaryFormGroup.value.merchantConfig}}</td>
      </tr>
      <tr>
        <td><b>Governmental merchant:</b></td>
        <td> {{SummaryFormGroup.value.governmentMerchant}}</td>
      </tr>
      <tr>
        <td><b>Card set:</b></td>
        <td> {{SummaryFormGroup.value.cardSet}}</td>
      </tr>
      <tr>
        <td><b>Country:</b></td>
        <td> {{SummaryFormGroup.value.country}}</td>
      </tr>
      <tr>
        <td><b>Region:</b></td>
        <td> {{SummaryFormGroup.value.region}}</td>
      </tr>
      <tr>
        <td><b>merchant type:</b></td>
        <td> {{SummaryFormGroup.value.merchantType}}</td>
      </tr>
      <tr>
        <td><b>Slip header:</b></td>
        <td> {{SummaryFormGroup.value.slipHeader}}</td>
      </tr>
      <tr>
        <td><b>Slip trailer:</b></td>
        <td> {{SummaryFormGroup.value.slipTrailer}}</td>
      </tr>
      <tr>
        <td><b>Merchant delivery address:</b></td>
        <td> {{SummaryFormGroup.value.merchantStreetAddress}}</td>
      </tr>
      <tr>
        <td><b>Sub merchant id:</b></td>
        <td> {{SummaryFormGroup.value.subMerchantId}}</td>
      </tr>
      <tr>
        <td><b>Payment facilitator id:</b></td>
        <td> {{SummaryFormGroup.value.paymentFacilitatorId}}</td>
      </tr>
      <tr>
        <td><b>Payment facilitator id visa:</b></td>
        <td> {{SummaryFormGroup.value.paymentFacilitatorIdVisa}}</td>
      </tr>
      <tr>
        <td><b>Independent sales organization id:</b></td>
        <td> {{SummaryFormGroup.value.independentSalesOrganizationId}}</td>
      </tr>
      <tr>
        <td><b>Independent sales organizationId visa:</b></td>
        <td> {{SummaryFormGroup.value.independentSalesOrganizationIdVisa}}</td>
      </tr>
      <tr>
        <td><b>Customer service phone number:</b></td>
        <td> {{SummaryFormGroup.value.customerServicePhoneNo}}</td>
      </tr>
      <tr>
        <td><b>Merchant verification value:</b></td>
        <td> {{SummaryFormGroup.value.merchantVerificationValue}}</td>
      </tr>

      <tr>
        <td><b>Notes:</b></td>
        <td> {{SummaryFormGroup.value.notes}}</td>
      </tr>
      <tr>
        <td style="background-color: #348cd4; color: white" colspan="2"><b>Contact information section</b></td>
      </tr>
      <tr>
        <td><b>Name:</b></td>
        <td> {{SummaryFormGroup.value.contactName}}</td>
      </tr>
      <tr>
        <td><b>Surname:</b></td>
        <td> {{SummaryFormGroup.value.contactSurname}}</td>
      </tr>
      <tr>
        <td><b>Work number:</b></td>
        <td> {{SummaryFormGroup.value.contactNumber}}</td>
      </tr>
      <tr>
        <td><b>Cell number:</b></td>
        <td> {{SummaryFormGroup.value.cellNumber}}</td>
      </tr>
      <tr>
        <td><b>Email address:</b></td>
        <td> {{SummaryFormGroup.value.emailAddress}}</td>
      </tr>
      <tr>
        <td><b>Physical address:</b></td>
        <td> {{SummaryFormGroup.value.physicalAddress}}</td>
      </tr>
      <tr>
        <td style="background-color: #348cd4; color: white" colspan="2"><b>Terminals information section</b></td>
      </tr>
      <tr>
        <td><b>Terminal delivery:</b></td>
        <td> {{SummaryFormGroup.value.terminalDelivery}}</td>
      </tr>

      <tr>
        <td style="text-align:left"><b>Terminals:</b></td>
        <td>

          <div *ngFor="let terms of SummaryFormGroup.value.terminals; let i = index">

            <div *ngIf="!isbulkOrder">
              <br />
              <b style="color: #477c93;"> Terminal details</b>
              <div class="-divider dropdown-divider" style="border: 1px solid #348cd4"></div>
              <br />
            </div>

            <b style="font-weight: bold;">Terminal id: </b> {{ terms.terminalId }} <br />
            <div *ngIf="!isbulkOrder">
              <b style="font-weight: bold;">Terminal number: </b> {{ terms.terminalNumber }} <br />
              <b style="font-weight: bold;">Terminal type: </b> {{ terms.terminalType }} <br />
              <b style="font-weight: bold;">Device make: </b>{{ terms.deviceMake }}<br />
              <b style="font-weight: bold;">Device model: </b>{{ terms.deviceModel }}<br />
              <b style="font-weight: bold;">Terminal type: </b> {{ terms.terminalType }}<br />
              <b style="font-weight: bold;">Product profile: </b> {{ terms.productProfile }}<br />
              <b style="font-weight: bold;">Terminal capabilities: </b> {{ terms.terminalCapabilities }}<br />
              <b style="font-weight: bold;">Comms profile: </b> {{ terms.commsProfile }}<br />

              <b style="font-weight: bold;">Terminal active: </b>{{ terms.terminalActive }}<br />
              <b style="font-weight: bold;">Manual pan entry: </b>{{ terms.manualPanEntry }}<br />
              <b style="font-weight: bold;">Contactless: </b>{{ terms.contactless }}<br />
              <b style="font-weight: bold;">Banking window time: </b>{{ terms.bankingWindowTime }}<br />

              <b style="font-weight: bold;">Parameter download day: </b>{{ terms.parameterDownloadDay }}<br />
              <b style="font-weight: bold;">Parameter download window time: </b>{{ terms.parameterDownloadWindowTime }}<br />

              <b style="font-weight: bold;">Contact name & surname: </b>{{ terms.nameSurname }}<br />
              <b style="font-weight: bold;">Contact cell number: </b>{{ terms.ContactNameCellNr }}<br />
              <b style="font-weight: bold;">Contact email address: </b>{{ terms.ContactEmailAddress }}<br />
              <b style="font-weight: bold;">Delivery address: </b>{{ terms.address }}<br />
              <b style="font-weight: bold;">Region: </b>{{ terms.region }}<br />
              <b style="font-weight: bold;">City: </b>{{ terms.city }}<br />
              <b style="font-weight: bold;">Town: </b>{{ SummaryFormGroup.value.town }}<br />
              <b style="font-weight: bold;">Postal service code: </b>{{ terms.postalcode }}<br />
            </div>
            <hr style="color:teal" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>

</form>
